import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { MultiselectCategoryListViewImpl } from './multiselectcategorylistview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { MultiselectCategoryListCSSStyleImpl } from './multiselectcategorylistcss';
import { CategoryDto } from '../../../../../core/dto/categories/categorydto';

export interface MultiselectCategoryListComponentProps extends UIComponentProps
{
    isEditable: boolean;
    seletedCategories: string[];
    listOfDatas: CategoryDto[];
    title: string;
}

export interface MultiselectCategoryListComponentState extends UIComponentState
{
    listOfDatas: CategoryDto[];
    isEditable: boolean;
    seletedCategories: string[];
}

export class MultiselectCategoryListComponent extends UIComponentImpl<MultiselectCategoryListComponentProps, MultiselectCategoryListComponentState, UIDataModel>
{
    constructor(props: MultiselectCategoryListComponentProps)
    {
        super(props);

        this.state = {seletedCategories: props.seletedCategories, isEditable: props.isEditable,  listOfDatas: props.listOfDatas};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MultiselectCategoryListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MultiselectCategoryListCSSStyleImpl(applicationContext);
    }

    UNSAFE_componentWillReceiveProps(nextProps: MultiselectCategoryListComponentProps)
    {
        this.setState({isEditable: nextProps.isEditable, seletedCategories: nextProps.seletedCategories});
    }

    getSelectedMultiselectCategoryList(): string[]
    {
        console.log("getSelectedMultiselectCategoryList:");
        return (this.getView() as MultiselectCategoryListViewImpl).getSelectedMultiselectCategoryList();
    }

    updateListData(listOfDatas: CategoryDto[])
    {
        this.setState({listOfDatas: listOfDatas});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/multiselectcategorylistcomponent.tsx